import {Injectable} from '@angular/core';

import 'rxjs/add/operator/toPromise';

import {User} from '../model/Entities/User';
import 'rxjs/add/operator/map';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import {ApiService} from './api.service';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/do';
import {Document} from '../model/Entities/Document';
import {PaymentType, PaymentTypeEntity} from '../model/Entities/PaymentType';

@Injectable()
export class PaymentTypeService extends ApiService<PaymentTypeEntity> {

    protected apiUrl = 'api/payment-type';  // URL to web api

    protected getObjectType(): any {
        return PaymentTypeEntity;
    }
}



// WEBPACK FOOTER //
// /app/src/services/payment-type.service.ts